export const moralis_api_key = "HV89lXbKopAQ18kFoxDqdFmZjvkMfLJdLInsQbmgoD4n8auZFYMX0KICEjqU6QrM";